import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Slider {
    constructor() {
        this.swiperInstaces = [];
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const wrappers = [...document.querySelectorAll(".c-swiper")];

        wrappers.forEach((el) => {
            const swiper = new Swiper(el, {
                loop: true,
                slidesPerView: "auto",

                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
            this.swiperInstaces.push(swiper);
        });
    }
}
